import { render, staticRenderFns } from "./RealtyAveragePrice.vue?vue&type=template&id=2e9555a4&"
import script from "./RealtyAveragePrice.vue?vue&type=script&lang=js&"
export * from "./RealtyAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports